import { Table } from "antd";

function WEDirectory({
	ready,
	tableColumns,
	filteredDataTable,
	dataTable,
}: any) {
	return (
		<div
			style={{
				width: "100%",
				flex: "1",
				position: "relative",
			}}
			className="table-content"
			id="table-container"
		>
			{ready && (
				<Table
					columns={tableColumns}
					dataSource={filteredDataTable || dataTable}
					// scroll={{ x: "max-content" }}
					rootClassName="custom-table status-indicator-table"
				/>
			)}
		</div>
	);
}

export default WEDirectory;
